import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { menu_data } from '../../data';
import { retrieveToken } from './../../hooks/use-token';

const NavMenu = () => {

  const [isLogged, setIsLogged] = useState(null);

  useEffect(() => {

    const tokenApi = retrieveToken();

    if (tokenApi)
      setIsLogged(true);
    else  
      setIsLogged(false);

  });

  function renderMenu(link) {

    if (isLogged) {

    return (<>
      <Link to={`${link.link}`}>{link.title}</Link>
          {link.submenu && <ul className="submenu">
            {link.submenu.map((menu) => (
            <li key={menu.id}>
              <Link to={`${menu.link}`}>{menu.title}</Link>
            </li>
            ))}
          </ul>}
    </>);

    } else {

      if (link.title !== 'Meu perfil' && link.title !== 'Acesse as videoaulas') {

        return (<>
          <Link to={`${link.link}`}>{link.title}</Link>
              {link.submenu && <ul className="submenu">
                {link.submenu.map((menu) => (
                <li key={menu.id}>
                  <Link to={`${menu.link}`}>{menu.title}</Link>
                </li>
                ))}
              </ul>}
        </>);

      }

    }

  }

  return (
    <>
      <ul>
        {menu_data.map((link,index) => (
        <li key={index} className={link.submenu ? "has-dropdown" : ''}>
          {renderMenu(link)}
        </li>
        ))}

      </ul>
    </>
  );
};

export default NavMenu;